import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaCreditCard, FaPaypal, FaLock } from "react-icons/fa";


const DonationPage = () => {
    const [amount, setAmount] = useState(10); // Valeur par défaut : 10€
    const navigate = useNavigate();

    const [paymentMethod, setPaymentMethod] = useState(null);

    const handlePayment = (method) => {
        setPaymentMethod(method);
    };
	
    const redirectToPayPal = () => {
        window.location.href = `https://www.paypal.com/checkoutnow?amount=${amount}`;
    };


    const handleDonation = () => {
        navigate(`/event/payment?amount=${amount}`);
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 px-4">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-2xl w-full text-center">
                <h1 className="text-2xl font-bold text-gray-800">Soutenez nous, merci!</h1>
                <p className="text-gray-600 mt-2">
                    Aidez-nous à promouvoir le covoiturage pour tous. <br />
					Pour survivre et continuer à payer tous nos frais: <br />
					Hébergement, géolocalisation, cartographophie, cybersécurité, etc. <br />
					Nous avons besoin de vos dons.
                </p>
                
                {/* Sélecteur de montant */}
                <div className="mt-6">
                    <label className="block text-gray-700 font-medium text-left text-center">Choisissez le montant du don</label>
                    <div className="flex mt-2 max-w-xs w-auto mx-auto">
                        <input 
                            type="number"
                            min="1"
                            value={amount}
                            onChange={(e) => setAmount(Number(e.target.value))}
                            className="flex-1 px-4 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                        />
                        <span className="px-4 py-2 bg-gray-200 border border-gray-300 rounded-r-md">€</span>
                    </div>
                </div>


                <div className="mt-6 flex justify-center space-x-6">
                    <button onClick={() => handlePayment("CB")} className="flex items-center bg-blue-500 text-white px-6 py-3 rounded-md shadow-md hover:bg-blue-600 transition">
                        <FaCreditCard className="mr-2" /> Payer par Carte Bancaire
                    </button>
                    <button onClick={() => handlePayment("PayPal")} className="flex items-center bg-yellow-500 text-white px-6 py-3 rounded-md shadow-md hover:bg-yellow-600 transition">
                        <FaPaypal className="mr-2" /> Payer par PayPal
                    </button>
                </div>

                <p className="text-sm text-gray-500 mt-4">
                    Merci pour votre soutien ❤️
                </p>
				
				
				{paymentMethod === "CB" && (
					<div className="mt-6 p-6 border rounded-lg shadow-md">
						<h2 className="text-xl font-semibold text-gray-700 mb-4">Paiement sécurisé de {amount}€ par Carte Bancaire</h2>
						<form>
							<label className="block text-sm font-medium text-gray-700">Numéro de Carte</label>
							<input type="text" className="w-full p-3 border rounded-md mb-4" placeholder="1234 5678 9012 3456" />
							
							<div className="grid grid-cols-2 gap-4">
								<div>
									<label className="block text-sm font-medium text-gray-700">Date d'Expiration</label>
									<input type="text" className="w-full p-3 border rounded-md" placeholder="MM/AA" />
								</div>
								<div>
									<label className="block text-sm font-medium text-gray-700">CVV</label>
									<input type="text" className="w-full p-3 border rounded-md" placeholder="123" />
								</div>
							</div>
							
							<button type="submit" className="mt-6 w-full bg-green-500 text-white py-3 rounded-md shadow-md hover:bg-green-600 transition flex items-center justify-center">
								<FaLock className="mr-2" /> Valider le Paiement
							</button>
						</form>
					</div>
				)}
				
				{paymentMethod === "PayPal" && (
					<div className="mt-6 p-6 border rounded-lg shadow-md text-center">
						<h2 className="text-xl font-semibold text-gray-700 mb-4">Paiement via PayPal</h2>
						<p className="text-gray-600">Vous allez être redirigé vers PayPal pour finaliser le paiement.</p>
						<button onClick={redirectToPayPal} className="mt-4 bg-yellow-500 text-white px-6 py-3 rounded-md shadow-md hover:bg-yellow-600 transition">
							Continuer vers PayPal
						</button>
					</div>
				)}				
				
				
				
            </div>
			

			
        </div>
    );
};

export default DonationPage;
